import React, { Component, PropTypes } from 'react'
import Link from 'gatsby-link'

import './index.scss'

class RowDetail extends Component {
  render () {
    const { children, title, value } = this.props

    return (
      <div className="row top-xs between-xs">
        <h6 className="col-xs-7 col-md-16">{title}</h6>
        <p className="col-xs-9 col-md-16">{value}</p>
      </div>
    )
  }
}

RowDetail.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  value: PropTypes.string,
}

export default RowDetail



// WEBPACK FOOTER //
// ./src/components/RowDetail/index.js